import { render, staticRenderFns } from "./SelectRegion.vue?vue&type=template&id=62282948&scoped=true&"
import script from "./SelectRegion.vue?vue&type=script&lang=js&"
export * from "./SelectRegion.vue?vue&type=script&lang=js&"
import style0 from "./SelectRegion.vue?vue&type=style&index=0&id=62282948&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62282948",
  null
  
)

export default component.exports